import { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { motion } from 'framer-motion';
import { clientConfig } from "../../awsClientConfig";
import { userProfileData } from "../../Common/profileInfo";
import { formatNumber } from "../../functions/misc";
import { useNavigate } from "react-router-dom";
import { GetReferralCount } from "../../queries/GetReferralCount";



export default function EnrolledClients(this: any) {

    const client = new clientConfig();
    const navigate = useNavigate();

   const [count, setCount] = useState<number | null>(null);
    const motionItem = {
        initial: { opacity: 0 },
        animate: { opacity: 1, transition: { ease: "easeInOut" } },
    };

    const getSummary = async () => {
        const partnerId = await userProfileData();
        client
            .query({
                query: GetReferralCount,
                variables: { "PartnerId": partnerId, "Limit": 10,
                "NextToken": "1",  LeadStatus: "Enrolled"},
            })
            .then((res: any) => {
                setCount(res.data.GetLeadsByPartner.TotalRecords)

            });
    };

    useEffect(() => {
        getSummary();
    }, []);

    return (
        <section className="enrolledClients">
            <Card className="border-0 w-100">
                <Card.Header>
                    <h6 className="mt-3 ff-Montserrat fs-6">
                        Enrolled Clients
                    </h6>
                </Card.Header>
                <Card.Body>
                    <motion.h1 key={count} className="material-blue text-center ff-Montserrat a-link-content-text" {...motionItem}   onClick={() => navigate('/partner-referrals', { state: { filterBy: 'Enrolled' } })} >
                    {formatNumber(count)}
                    </motion.h1>
                </Card.Body>
            </Card>
        </section>
    );
}